import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AnalyticEvent, AnalyticsBloc } from '@kanalytics';
import { NavigationBloc } from '@kbloc';
import { EnvironmentVariablesService } from '@kenv';
import { Constants } from '@kp/shared/constants.service';
import { UserBloc } from '@kp/user/user.bloc';
import { ThemeService, WINDOW, productDisplayName } from '@kservice';
import { AppSwitchLocation, Product } from '@ktypes/enums';
import { ProductInfo } from '@ktypes/models';

@Component({
  selector: 'kp-site-header',
  templateUrl: './site-header.component.html',
  styleUrls: ['./site-header.component.scss'],
})
export class SiteHeaderComponent {
  constructor(
    private _analyticsBloc: AnalyticsBloc,
    private _environmentVariablesService: EnvironmentVariablesService,
    public navigationBloc: NavigationBloc,
    private _router: Router,
    public themeService: ThemeService,
    private _userBloc: UserBloc,
    @Inject(WINDOW) private window: Window
  ) {}

  @Input() navActive: boolean;
  @Input() quickActionsOpen = false;
  @Output() navBtnClick = new EventEmitter<void>();

  @Output() quickActionsToggled = new EventEmitter<boolean>();
  constants = Constants;
  productName = productDisplayName;

  product = Product;

  externalProduct = this._environmentVariablesService.product;

  onNavBtnClick(e: MouseEvent) {
    if (this.navActive) {
      (this.window.document.activeElement as HTMLElement).blur();
    }
    this.navBtnClick.emit();
    this.quickActionsToggled.emit(false);
    e.preventDefault();
  }

  appClicked(app: ProductInfo) {
    if (!app?.currentApp) {
      this._userBloc.switchApplication(app.product);
      const event = this._analyticsBloc.createEventFromInteraction({
        event: AnalyticEvent.app_switch_requested,
        meta: {
          app_requested: app?.product,
          link_location: AppSwitchLocation.app_switcher,
          source_app: this.externalProduct,
        },
      });

      this._analyticsBloc.sendEvent(event);
    }
  }
}
